var LAYOUT = {
    FULLWIDTH: 'fullwidth',
    SIDEBARLEFT: 'sidebar-left',
    FULLWIDTH_LITE_HEADER: 'fullwidth-lite-header',
    FULLWIDTH_LITE_HEADER_NO_FOOTER: 'fullwidth-lite-header-no-footer'
};
export default LAYOUT;
